import React, { useMemo, useRef } from 'react';
import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';

export const useNavigation = (
  projectSpaceTypeCategories: IProjectSpaceTypeCategory[] = []
) => {
  const programSummaryRef = useRef(null);

  const refMap: Record<
    number,
    React.MutableRefObject<HTMLDivElement>
  > = useMemo(() => {
    return projectSpaceTypeCategories.reduce(
      (map, projectSpaceTypeCategory: IProjectSpaceTypeCategory) => ({
        ...map,
        [projectSpaceTypeCategory.id]: React.createRef(),
      }),
      {}
    );
  }, [projectSpaceTypeCategories]);

  return {
    programSummaryRef,
    refMap,
  };
};
